export default "__VITE_ASSET__6f45dffd__"